'use strict';

const jQuery = require('jquery');

export default ReportNatureCategorySelect;

const REPORT_NATURE_CATEGORY_SELECT_COMPONENT_ATTR = 'data-report-nature-category-select';
const REPORT_NATURE_CATEGORY_SELECT_COMPONENT_SELECTOR = '[' + REPORT_NATURE_CATEGORY_SELECT_COMPONENT_ATTR + ']';
const REPORT_NATURE_CATEGORY_SELECT_CATEGORY = '[data-report-nature-category-select-category]';
const REPORT_NATURE_CATEGORY_SELECT_ELEMENT = '[data-report-nature-category-select-element]';
const REPORT_NATURE_CATEGORY_BUTTON_GENERATE = '[data-report-nature-category-select-generate]';
const REPORT_NATURE_CATEGORY_SELECT_EMPTY_TEMPLATE = '<option selected disabled>Maak een keuze...</option>';

class ReportNatureCategorySelect {

    constructor(element) {
        const component = this;

        component.element = jQuery(element);
        component.selectCategory = component.element.find(REPORT_NATURE_CATEGORY_SELECT_CATEGORY);
        component.buttonGenerate = component.element.find(REPORT_NATURE_CATEGORY_BUTTON_GENERATE);

        component.buttonGenerate.prop('disabled', true);

        component.selectCategory.on('change', () => {
            component.buttonGenerate.prop('disabled', false);
        });
    }

}

jQuery(REPORT_NATURE_CATEGORY_SELECT_COMPONENT_SELECTOR).each((index, element) => new ReportNatureCategorySelect(element));
